import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationCard = ({ type, client, date, time, value, onClick }) => {
  const getNotificationIcon = () => {
    switch (type) {
      case 'appointment':
        return 'Calendar';
      case 'delivery':
        return 'Package';
      case 'deadline':
        return 'Clock';
      default:
        return 'Bell';
    }
  };

  const getNotificationColor = () => {
    switch (type) {
      case 'appointment':
        return 'bg-blue-100 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400';
      case 'delivery':
        return 'bg-yellow-100 dark:bg-yellow-900/20 text-yellow-600 dark:text-yellow-400';
      case 'deadline':
        return 'bg-red-100 dark:bg-red-900/20 text-red-600 dark:text-red-400';
      default:
        return 'bg-purple-100 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400';
    }
  };

  const getNotificationTitle = () => {
    switch (type) {
      case 'appointment':
        return 'Upcoming Appointment';
      case 'delivery':
        return 'Delivery Due Soon';
      case 'deadline':
        return 'Deadline Approaching';
      default:
        return 'Notification';
    }
  };

  return (
    <div 
      className="flex items-start gap-3 md:gap-4 p-3 md:p-4 rounded-xl bg-card border border-border hover:border-primary/50 transition-smooth cursor-pointer"
      onClick={onClick}
    >
      <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${getNotificationColor()}`}>
        <Icon name={getNotificationIcon()} size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="font-medium text-sm md:text-base text-foreground mb-1">{getNotificationTitle()}</h4>
        <p className="text-sm md:text-base text-foreground truncate mb-1">{client}</p>
        <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
          <Icon name="Clock" size={12} />
          <span>{date} at {time}</span>
        </div>
        {value && (
          <p className="text-sm md:text-base font-semibold text-foreground mt-2">₹{value?.toLocaleString()}</p>
        )}
      </div>
      <Icon name="ChevronRight" size={20} className="text-muted-foreground flex-shrink-0" />
    </div>
  );
};

export default NotificationCard;